// tslint:disable:no-any
import { Link } from '../common';
import { ShipmentLocationType } from './shipment-location-type';

export interface IShipmentLocation {
  links: Link | any;
  shipmentLocationId: number;
  shipmentLocationDesc: string;
  shipmentLocationCode: string;
  shipmentLocationType: ShipmentLocationType;
  address: { addressId: number; links: Link | any };
}
